import { Alert, Button, Modal } from '@yoast/ui-library';

import type { Extracted } from './CollectedInfoPanel';
import { formatFieldDisplay, isFieldFilled, ORDERED_FIELDS, FIELD_LABELS } from './fieldUtils';

type Props = {
  isOpen: boolean;
  extracted: Extracted | null;
  onClose: () => void;
  onConfirm: () => void;
};

const ConfirmBrandProfileModal = ({ isOpen, extracted, onClose, onConfirm }: Props) => {
  const filledFields = extracted
    ? ORDERED_FIELDS.filter((field) => isFieldFilled(field, extracted[field]))
    : [];

  return (
    <Modal isOpen={isOpen} onClose={onClose} position="center">
      <Modal.Panel className="yst-max-w-[95vw] sm:yst-max-w-3xl yst-rounded-xl yst-bg-white">
        <Modal.Container>
          <Modal.Container.Header className="yst--mx-6 yst-border-b yst-border-slate-200 yst-px-6 yst-pb-5">
            <Modal.Title as="h2" className="yst-text-xl yst-font-semibold yst-text-slate-900">
              Confirm brand profile
            </Modal.Title>
          </Modal.Container.Header>

          <Modal.Container.Content className="yst-space-y-8 yst-pt-6">
            <Alert variant="warning">
              Once you generate queries, this brand profile can no longer be edited. To
              make changes, you&apos;ll need to start a new analysis from scratch.
            </Alert>

            <div className="yst-divide-y yst-divide-slate-200">
              {filledFields.map((field) => (
                <div
                  key={field}
                  className="yst-grid yst-grid-cols-1 sm:yst-grid-cols-[200px_1fr] yst-gap-2 sm:yst-gap-6 yst-py-5"
                >
                  <div className="yst-text-xs yst-font-semibold yst-uppercase yst-tracking-wider yst-text-slate-500">
                    {FIELD_LABELS[field]}
                  </div>
                  <div className="yst-text-base yst-text-slate-900 yst-whitespace-pre-wrap">
                    {formatFieldDisplay(field, extracted?.[field])}
                  </div>
                </div>
              ))}
            </div>
          </Modal.Container.Content>

          <Modal.Container.Footer className="yst-flex yst-justify-end yst-gap-2">
            <Button variant="secondary" onClick={onClose}>
              Back to chat
            </Button>
            <Button variant="ai-primary" onClick={onConfirm}>
              Generate queries
            </Button>
          </Modal.Container.Footer>
        </Modal.Container>
      </Modal.Panel>
    </Modal>
  );
};

export default ConfirmBrandProfileModal;
